import Styles from './styles.module.css';
import React, { useState } from 'react';
import { doc, getFirestore, setDoc } from 'firebase/firestore';
import { TbNumber1Small, TbNumber2Small, TbNumber3Small, TbNumber4Small, TbNumber5Small, TbNumber6Small, TbNumber7Small, TbNumber8Small } from 'react-icons/tb';
import { PiCheckCircleFill } from 'react-icons/pi';
import { VscChevronRight } from 'react-icons/vsc';

// 中途採用「求人票の編集」用のセクション切替ナビゲーション。
// 新卒側(2.jobPostings/edit/navigation)と違い、PDF生成・検索インデックス登録は
// 行わない(アプリ側が中途採用に未対応のため)。「公開」ボタンは
// jobPostingsStatus を 1 にするだけ(アプリ掲載等の仕組みは別途検討)。
// 募集区分(Target)・18歳卒/17歳卒の雇用条件は中途採用に該当しないため扱わない。

export const MID_CAREER_JOB_POSTING_SECTIONS = [
  "魅力",
  "企業情報",
  "店舗情報",
  "雇用条件",
  "福利厚生",
  "採用情報",
  "パンフレット",
  "ハッシュタグ",
];

const numberIcons = [
  <TbNumber1Small className={Styles.nav_number} />,
  <TbNumber2Small className={Styles.nav_number} />,
  <TbNumber3Small className={Styles.nav_number} />,
  <TbNumber4Small className={Styles.nav_number} />,
  <TbNumber5Small className={Styles.nav_number} />,
  <TbNumber6Small className={Styles.nav_number} />,
  <TbNumber7Small className={Styles.nav_number} />,
  <TbNumber8Small className={Styles.nav_number} />,
];

type MidCareerJobPostingNavigationProps = {
  progress: boolean[];
  changeData: boolean;
  navigation: number;
  setNavigation: React.Dispatch<React.SetStateAction<number>>;
  setBackCaution: React.Dispatch<React.SetStateAction<number>>;
  companyId: string;
  documentId: string;
  jobPostingDocId: string;
  published: boolean;
};

const MidCareerJobPostingNavigation: React.FC<MidCareerJobPostingNavigationProps> = ({
  progress, changeData, navigation, setNavigation, setBackCaution,
  companyId, documentId, jobPostingDocId, published,
}) => {
  const db = getFirestore();
  const [uploading, setUploading] = useState(false);

  const allCompleted = progress.length > 0 && progress.every(Boolean);

  const publicDoc = async () => {
    if (!companyId || !documentId || !jobPostingDocId) return;
    setUploading(true);
    try {
      // 求人票専有データが入っているサブコレクション側を正としつつ、
      // フラットドキュメント側にもフラグをミラーする(新卒側と同じ扱い)。
      await setDoc(
        doc(db, 'recruits', companyId, 'jobPostings', jobPostingDocId),
        { jobPostingsStatus: 1 },
        { merge: true },
      );
      await setDoc(
        doc(db, 'recruits', documentId),
        { jobPostingsStatus: 1 },
        { merge: true },
      );
    } catch (error) {
      console.error('中途採用求人票の公開に失敗しました:', error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className={Styles.navigation}>
      <h4 className={Styles.navigation_title}>求人票の編集(中途)</h4>

      {MID_CAREER_JOB_POSTING_SECTIONS.map((label, index) => {
        const num = index + 1;
        const isActive = navigation === num;
        const isCompleted = progress[num - 1];

        return (
          <div className={Styles.navigation_item}
            key={num}
            onClick={() => (changeData && navigation !== num ? setBackCaution(num) : setNavigation(num))}
            style={{ backgroundColor: isActive ? "#EBEBEB" : "" }}>
            <p>
              {numberIcons[index]}
              {label}
            </p>

            {isCompleted ? (
              <PiCheckCircleFill className={Styles.save} />
            ) : (
              <VscChevronRight className={Styles.unSave} />
            )}
          </div>
        );
      })}

      {published ? (
        <span className={Styles.chip_published}>
          <PiCheckCircleFill className={Styles.save} />公開済み
        </span>
      ) : (
        <button
          type="button"
          className={Styles.save_btn}
          disabled={!allCompleted || uploading}
          onClick={publicDoc}
        >
          {uploading ? '公開中...' : '公開'}
        </button>
      )}
    </div>
  );
};

export default MidCareerJobPostingNavigation;
